module.exports = __webpack_public_path__ + "assets/img/00047.c8079667.png";